const pixelify = (string) => (string ? `${string}px` : undefined);

export default pixelify;
